export const BASE_URL = "https://hirelinkinfo.com/hirelink_apis/";


